import Axios from "./axios";

const resource = "about-us-sections";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}